import { Button, Fade, Link, Stack, Typography } from '@mui/material';
import { FLUX_4_URL, SUPPORT_MAILTO } from '@features/base/private/components/MigrationBanner';
import { useAppAuthentication } from '@hooks/useAppAuthentication';
import theme from '@shared/themes/darkTheme';

export default function AppRetiredPage() {
  const { handleLogout } = useAppAuthentication();

  return (
    <Fade in>
      <Stack display="flex" flexDirection="column" flex={1} justifyContent="center" alignItems="center" gap={4} minHeight="100vh" px={2}>
        <Typography variant="h2" textAlign="center" fontWeight={700} fontSize={36} lineHeight={1.2}>
          Flux 3.0 has been retired
        </Typography>
        <Typography variant="body1" color={theme.palette.text.secondary} textAlign="center" maxWidth={600} fontSize={18} lineHeight={1.5}>
          Flux 3.0 is no longer available. Please continue in Flux 4.0, our new, faster and more advanced platform.
        </Typography>
        <Button variant="contained" size="large" href={FLUX_4_URL} sx={{ fontSize: 18, px: 4, py: 1.5 }}>
          Go to Flux 4.0
        </Button>
        <Stack direction="row" alignItems="center" gap={3}>
          <Link href={SUPPORT_MAILTO} fontSize={16}>
            Contact support
          </Link>
          <Button variant="text" onClick={handleLogout} sx={{ fontSize: 16 }}>
            Log out
          </Button>
        </Stack>
      </Stack>
    </Fade>
  );
}
